import { render, staticRenderFns } from "./ContractBasicInfo.vue?vue&type=template&id=7fa10bff&"
import script from "./ContractBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ContractBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports